<template>
  <el-dialog :visible.sync="show" :title="$t('m.add_remark')" @close="onDialogClose('theForm')" :close-on-click-modal="false" :append-to-body="true">
    <el-form size="small" :model="model" :rules="rules" label-position="left" label-width="80px" ref="theForm">
      <el-form-item :label="$t('m.remark')" prop="remark">
        <el-input v-model="model.remark"  :placeholder="$t('m.add_remark')" maxlength="10"></el-input>
      </el-form-item>
      <!-- <el-form-item :label="$t('m.remark')" prop="remark">
        <el-autocomplete v-model="model.remark" :fetch-suggestions="querySearchAsync" placeholder="请输入内容"></el-autocomplete>
      </el-form-item> -->
    </el-form>
    <span slot="footer">
      <el-button @click="show = false" size="small">{{$t('m.cancel')}}</el-button>
      <el-button type="primary" @click="doRemarkAdd" size="small" :loading="loading.btn">{{$t('m.Confirm')}}</el-button>
    </span>
    
  </el-dialog>
</template>

<script>

import { addOrRemoveRemarkInfo } from '../../../api/approval/anchor-approval';

export default {
  name: 'user-label-add-dialog',

  data() {
    return {
      loading: {
        table: true,
        btn: false
      },
      specialDescList: [],
      descList: [],
      timeout: null,
      show: false,
      model: {
        remark: null,
        id: null,
        remarkType: 1
      },
      userLabelList: [],
      rules: {
        remark: [
          {
            required: true,
            trigger: 'change',
            message: this.$t('m.no_data')
          }
        ]
      },
      row: null
    };
  },

  methods: {
    // querySearchAsync(queryString, cb) {
    //   var restaurants = this.descList;
    //   console.log(restaurants);
    //   var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(() => {
    //     cb(results);
    //   }, 3000 * Math.random());
    // },
    // createStateFilter(queryString) {
    //   return (item) => {
    //     return (item.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
    //   };
    // },
    // initSpecialDescIdListData() {
    //   getSpecialDescIdList()
    //     .then(({ data }) => {
    //       this.descList = data.list;
    //       for(let i=0; i<this.descList.length; i++) {
    //         this.descList[i].value = this.descList[i].name;
    //       }
    //       console.log(this.descList);
    //     })
    //     .catch(errorMsg => {});
    // },
    showDialog(row) {
      this.model.id = row.id;
      this.show = true;
    },
    doRemarkAdd() {
      this.$refs.theForm.validate(valid => {
        if (!valid) {
          return;
        }
        this.loading.btn = true;
        addOrRemoveRemarkInfo(this.model)
          .then(resp => {
            this.$message.success(this.$t('m.oper_success'));
            this.loading.btn = false;
            this.show = false;
          })
          .catch(error => {
            this.loading.btn = false;
          })
      })
    },


    deleteRowInfo(row){
      console.log(row);
      let model = {
        userId: this.model.userId,
        specialDescId: row.id
      }
      this.loading.table = true;
      removeSpecialDescInfo(model)
      .then(({data}) =>{
        this.$message({
          type:'success',
          message: '删除成功'
          //刷新表格数据
        });
      })
    },

    onDialogClose(formRef) {
      this.$emit('done');
      this.$refs[formRef].resetFields();
    }
  }
};
</script>
<style scoped>
  .ab_label {
    position: absolute;
    right:0;
    top: 0;
    width: 0;
    height: 0;
    border-top: 10px solid #55aaff;
    border-left: 10px solid transparent;
  }
 .cd_label {
    border-top: 10px solid #55aa7f;
  }
</style>



// WEBPACK FOOTER //
// src/pages/approval/dialogs/UserRemarkDialog.vue